export default __webpack_public_path__ + "static/media/new-report-disabled.988fa3e0.svg";